/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, Tc) {
	'use strict';

	Tc.Module.VideoContainer = Tc.Module.extend({

		// Offset required to prevent scrollbars
		paddingOffset: 7,

		config: {
			dataVideoFileReference: 'fileReference',
			dataTargetDivId: 'videoContainerId',
			dataVideoHeight: 'videoHeight',
			dataVideoWidth: 'videoWidth',
			dataIsS7Video: 'iss7video'
		},

        autostart : false,

		videoSizeInit: function() {
			var videoWidth = 0,
			videoHeight = 0;
			
			var apsWidth = Math.round($(window).width() * 0.95 - 5);
			var apsHight = Math.round($(window).height() * 0.95 - 5);
			
			debug.log('Tc.Module.VideoContainer > APS > apsWidth, apsHight', apsWidth, apsHight);
			
			if ((apsWidth / apsHight ) > 16/9) {
				videoHeight = apsHight - 70;				
				videoWidth = videoHeight * (16/9);
			} 
			else {
				videoHeight = apsWidth / (16/9);
				videoWidth = apsWidth;
			}
			
			videoWidth = Math.round(videoWidth);
			videoHeight = Math.round(videoHeight);
			$('#s7ViewerContainer').width((videoWidth) + 'px');
			$('#s7ViewerContainer').height((videoHeight)  + 'px');

			debug.log('Tc.Module.VideoContainer > Calculated > videoWidth, videoHeight', videoWidth, videoHeight);

			// do not start brightcove player when page loads, it should start when overlay load is done.
            this.autostart = $('#s7ViewerContainer').find('.modBrightcoveVideo').data('autostart');
            debug.log('Tc.Module.VideoContainer > ', this.autostart);
			$('#s7ViewerContainer').find('.modBrightcoveVideo').data('autostart', false);
		},

		on: function (callback) {
			var mod = this,
				$ctx = mod.$ctx,
				config = mod.config,
				resizeRatio = 1.00,
				videoWidth = '100%',
				videoHeight = '100%';

			mod.videoSizeInit();

			if ($ctx.data(config.dataVideoWidth.toLowerCase())) {
				var width = $ctx.data(config.dataVideoWidth.toLowerCase());
				if (width > $(window).width()) {
					resizeRatio = $(window).width() / width;
					width = $(window).width();
				}
				$('#s7ViewerContainer').width((width) + 'px');
				videoWidth = (width + mod.paddingOffset) + 'px';
			}

			if ($ctx.data(config.dataVideoHeight.toLowerCase())) {
				var height = $ctx.data(config.dataVideoHeight.toLowerCase());
				height = height * resizeRatio;
				$('#s7ViewerContainer').height((height) + 'px');
				videoHeight = (height + mod.paddingOffset) + 'px';
			}

			// responsive fix for colorbox from here
			// http://stackoverflow.com/questions/12182668/how-to-make-colorbox-responsive
			var cboxOptions = {
				maxWidth: videoWidth + 5,
				maxHeight: videoHeight + 5
			};

			$(window).resize(function () {
				$.colorbox.resize({
					width: window.innerWidth > parseInt(cboxOptions.maxWidth, 10) ? cboxOptions.maxWidth : cboxOptions.width,
					height: window.innerHeight > parseInt(cboxOptions.maxHeight, 10) ? cboxOptions.maxHeight : cboxOptions.height
				});
				mod.videoSizeInit();
			});

			$('.links7ViewerContainer').colorbox({
				width: '95%',
				height: '95%',
				inline: true,
//				maxWidth: cboxOptions.maxWidth,
//				maxHeight: cboxOptions.maxHeight,
				opacity: 0.6,
				href: function () {
					return '#s7ViewerContainer';
				},
				onClosed: function () {
                    if ($ctx.data(config.dataIsS7Video)) {
                    // scene7 viewer needs to be removed, otherwise it will start running in background.
						var child = $($('#s7ViewerContainer').children()[0]);
                    	child.remove();
					 } else {
						var origId = $('#s7ViewerContainer .video-player-wrapper div').attr('id');
                        if(window.videojs && origId && origId.toString) {
                            var playerO = window.videojs(origId.toString());
                            playerO.pause();
                        }
					}
				},
				onComplete: function () {
					// TODO test in IE
                    if ($ctx.data(config.dataIsS7Video)) {
						mod.s7EmbedOverlay();
					 } else {
                        setTimeout(function() {
						// player should start immediately when the colorboxy is opened
							var origId = $('#s7ViewerContainer .video-player-wrapper div').attr('id');
							if(window.videojs && mod.autostart && origId && origId.toString) {
                                var playerO = window.videojs(origId.toString());
								playerO.play();
                            }
						}, 250);
					};
				}
			});

			callback();
		},

		s7EmbedOverlay: function () {
			var mod = this,
				$ctx = mod.$ctx,
				config = mod.config,
				s7ViewerConfig = {
					flyoutLibraryPath: '',
					flyoutInitFilePath: '',
					assetContext: 'is/content/',
					locale: 'de',
					company: 'Swisscomvbc',
					useDivSize: true,
					roots: ['/skins/', '/s7viewers/'],
					cssRoot: '/skins/',
					codeUrl: '/s7viewers/',
					//contentUrl: '/skins/',
					contentUrl: 'is/content/',
					serverurl: 'http://swisscomvbc.scene7.com/is/image/',
					isr: 'https://swisscomvbc.scene7.com/',
					streamingRoot: 'rtmp://s7strmg2.scene7.com/s7strmg2/e2',
					progressiveRoot: 'http://swisscomvbc.scene7.com/e2/',
					streamingVideoUrl: 'rtmp://s7strmg2.scene7.com/s7strmg2/e2',
					progressiveVideoUrl: 'http://swisscomvbc.scene7.com/e2/',
					// type of embedded asset
					//	UNIVERSAL_VIDEO: 'VIDEO',
					//	UNIVERSAL_ZOOM: 'ZOOM',
					//	UNIVERSAL_IMAGE_SET: 'IMAGE_SET',
					//	UNIVERSAL_SWATCH_SET: 'RENDER_SET',
					//	UNIVERSAL_SPIN_SET: 'SPIN_SET_2D',
					//	UNIVERSAL_E_CAT: 'ECATALOG'
					assetType: 'VIDEO',
					// universal preset
					config: 'Swisscomvbc/Universal_Video1',
					asset: 'Swisscomvbc/' + $ctx.data(config.dataVideoFileReference.toLowerCase()),
					// container
					containerId: 's7ViewerContainer',
					flashMode: 'transparent',
					modifiers: {
						all: 'videoPlayer.autoPlay=1'
					}
				};

			mod.videoView = new window.s7uev.EmbeddedViewer(s7ViewerConfig);
		}
	});
}(window.Tc.$, window.Tc));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/emagazine/clientlibs/publish/js/modules/Tc.Module.VideoContainer.js
// module id = 46
// module chunks = 0